import Api from "../../../util/Api";

export default function getInitState() {
    return {
        formIsOpen: false,
        gridIsOpen: true,
        dataTableOptions: {
            server_mode: true,
            show_reset_button: false,
            global_search: {
                visibility: false,
            }
        },
        actions: [
            {
                btn_text: '<i class="fas fa-filter"></i> Szűrés',
                event_name: "customClick",
                class: "btn btn-primary my-custom-class",
                event_payload: 'showSearchModal'
            },
            {
                btn_text: '<i class="fas fa-plus"></i> Új vevő',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'newRow'
            }
        ],
        rowActions: [
            {
                btn_text: '<i class="fas fa-edit"></i>',
                title: 'Szerkesztés',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'modifyRow'
            },
            {
                btn_text: '<i class="fas fa-trash"></i>',
                title: 'Törlés',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'deleteRow'
            },
            {
                btn_text: '<i class="fas fa-undo"></i>',
                title: 'Visszaállítás',
                event_name: "customClick",
                class: "btn btn-outline-warning",
                seeCaseOfDeleted: true,
                event_payload: 'unDeleteRow'
            }
        ],
        searchFields: [
            {
                name: "customerName",
                label: "Név",
                formType: "text",
                formSize: 3,
                formVisible: true
            },
            {
                name: "company",
                label: "Vevő típusa",
                formType: 'select', 
                formSize: 2,
                formVisible: true,
                selectOptions: {
                    externalOptionList: [
                        {
                            id: "1",
                            text: 'Cég',
                            succesBoolean: 'true',
                        },
                        {
                            id: "2",
                            text: 'Magánszemély',
                            succesBoolean: 'false',
                        }
                    ],
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'succesBoolean',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "taxNumber",
                label: "Adószám",
                formType: "text",
                formSize: 3,
                formVisible: true
            },
            {
                name: "email",
                label: "E-mail cím",
                formType: "text",
                formSize: 4,
                formVisible: true
            },
            {
                name: "adoalany",
                label: "Adóalany",
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getAdoalanyListForCustomers,
                        formatText: function (val) {
                            return val.text;
                        },
                        formatOption: function (val) {
                            return val.text;
                        },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'szamlazzId',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 3,
                formVisible: true
            },
        ],
        headerFields: [
            {
                name: "id",
                label: "ID",
                visibility: false,
                formVisible: false
            },
            {
                name: "customerName",
                label: "Név",
                sort: true,
                visibility: true,
            },
            {
                name: "company",
                label: "Vevő típusa",
                sort: true,
                slot_name: "company_format",
                visibility: true,
            },
            {
                name: "customerEmail",
                label: "E-mail cím",
                visibility: true,
            },
            {
                name: "taxNumber",
                label: "Adószám",
                visibility: true,
            },
            {
                name: "taxablePersonText",
                label: "Adóalany",
                visibility: true,
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ]
    }
}
